import * as util from "./util"

/* To locally debug this script via Webflow the best option I've found is to
add two scripts in Webflow:
<script src="http://localhost:3000/????.bundle.js"></script>
<script src="angry-boyd-1669aa.netlify.app/????.bundle.js" crossorigin="anonymous"></script>
The below check ensures that if localhost loads successfully the second
(production) script won't run.
Initially I tried to add the script dynamically in Webflow but that didn't
work - I needed it to run immediately but it wouldn't. */
if (typeof SharesyWebflow === "undefined") {
  util.initSentry()

  window.amplitudeOnLoad = function (instance) {
    util.amplitudeInit(instance, "Booking Page Viewed", {
      "Space AB Test": util.getCookie("space_ab_test"),
    })
  }

  // Wrap everything with Revealing Module Pattern
  window.SharesyWebflow = (function () {
    var searchParams = util.getSearchParams()

    function updatePoptopSection(poptopSection, poptopLink) {
      if (!poptopSection || !poptopLink) {
        return
      }

      let sectionId = null
      let linkId = null

      if (poptopSection === "party") {
        sectionId = "poptop-section-party"
        linkId = "poptop-link-party"
      } else if (poptopSection === "non_party") {
        sectionId = "poptop-section-non-party"
        linkId = "poptop-link-non-party"
      } else {
        return
      }

      const section = document.getElementById(sectionId)
      if (section) {
        section.classList.remove("hide")
      }

      const link = document.getElementById(linkId)
      if (link) {
        let updatedLink = poptopLink
        let amplitudeDeviceId = null
        try {
          if (amplitude.getInstance()) {
            amplitudeDeviceId = amplitude.getInstance().options.deviceId
          }
        } catch (err) {}
        if (amplitudeDeviceId) {
          try {
            const parsed = new URL(poptopLink)
            parsed.searchParams.set("deviceid", amplitudeDeviceId)
            updatedLink = parsed.toString()
          } catch (err) {
            const joiner = poptopLink.includes("?") ? "&" : "?"
            updatedLink =
              poptopLink +
              joiner +
              "deviceid=" +
              encodeURIComponent(amplitudeDeviceId)
          }
        }
        link.href = updatedLink
      }

      const favourSection = document.getElementById("favour-section")
      if (favourSection) {
        favourSection.classList.add("hide")
      }
    }

    async function complete_booking() {
      const stripeSession = searchParams.get("session_id")
      const checkoutId = searchParams.get("checkout_id")
      if (stripeSession || checkoutId) {
        // complete-booking is idempotent so call it even on refreshes
        try {
          const data = await util.api
            .post("complete-booking", {
              json: {
                stripe_session_id: stripeSession,
                checkout_id: checkoutId,
              },
              retry: { limit: 0 },
            })
            .json()
          if (data.id) {
            document.getElementById("basket-image").src = data.space_image_url
            let basketSpace = document.getElementById("basket-space-name")
            basketSpace.innerText = data.space_name + ", " + data.venue_name
            basketSpace.href = "https://www.sharesy.com/s/" + data.space_slug
            document.getElementById("basket-ref").innerText = data.id

            let basketBottom = document.getElementById("basket-bottom")
            let basketAddons = document.getElementById("basket-addons")

            for (const session of data.sessions) {
              const newSessionDiv = document.createElement("div")
              basketBottom.insertBefore(newSessionDiv, basketAddons)
              newSessionDiv.classList.add("flex-between")
              const newSessionNameDiv = document.createElement("div")
              newSessionDiv.appendChild(newSessionNameDiv)
              newSessionNameDiv.innerText = session.friendly_times
              const newSessionPriceDiv = document.createElement("div")
              newSessionDiv.appendChild(newSessionPriceDiv)
              newSessionPriceDiv.innerText = "£" + session.price.toFixed(2)
              if (session.addons && session.addons.length > 0) {
                for (const addon of session.addons) {
                  const newAddonDiv = document.createElement("div")
                  basketAddons.insertBefore(newAddonDiv, basketAddons.lastChild)
                  newAddonDiv.classList.add("flex-between")
                  const addonNameDiv = document.createElement("div")
                  newAddonDiv.appendChild(addonNameDiv)
                  addonNameDiv.innerText = addon.name
                  const addonPriceDiv = document.createElement("div")
                  newAddonDiv.appendChild(addonPriceDiv)
                  addonPriceDiv.innerText =
                    "£" + parseFloat(addon.price).toFixed(2)
                }
                basketAddons.classList.remove("hide")
              }
            }
            if (data.sessions.length > 1) {
              basketAddons.classList.remove("hide")
            }
            document.getElementById("basket-grand-total").innerText =
              "£" + data.subtotal.toFixed(2)

            if (data.promo_code) {
              document.getElementById("total-paid").innerText = Number(
                data.stripe_total,
              ).toLocaleString("en-GB", {
                style: "currency",
                currency: "GBP",
              })
              document.getElementById("promo-code").innerText = data.promo_code
              document.getElementById("promo-total").innerText = Number(
                data.stripe_total - data.subtotal,
              ).toLocaleString("en-GB", {
                style: "currency",
                currency: "GBP",
              })
              document.getElementById("promo-section").classList.remove("hide")
              document.getElementById("total-section").classList.remove("hide")
            }
            updatePoptopSection(data.poptop_section, data.poptop_link)
            util.logAmplitudeEvent("Purchase Succeeded")
            // Only do this once per booking; rely on localStorage to avoid double-fires.
            const conversionKey = `sharesy_conversion_${data.id}`
            let conversionAlreadyTracked = false
            try {
              conversionAlreadyTracked =
                localStorage.getItem(conversionKey) === "1"
            } catch (err) {}
            if (conversionAlreadyTracked) {
              util.logAmplitudeEvent("Previously Purchased")
            }
            if (!conversionAlreadyTracked) {
              try {
                let revenue = new amplitude.Revenue()
                  .setPrice(data.stripe_total)
                  .setQuantity(1)
                amplitude.getInstance().logRevenueV2(revenue)
              } catch (err) {}
              try {
                let expected_commission = data.stripe_total * 0.15
                const conversionPayload = {
                  send_to: "AW-344077360/jObUCK77muIbELDoiKQB",
                  value: expected_commission,
                  currency: "GBP",
                  transaction_id: data.id,
                }
                const ensureAdsTag = () => {
                  if (!window.dataLayer) {
                    window.dataLayer = []
                  }
                  if (typeof window.gtag !== "function") {
                    window.gtag = function () {
                      window.dataLayer.push(arguments)
                    }
                  }
                  if (!window.__adsTagInitialised) {
                    window.__adsTagInitialised = true
                    window.gtag("js", new Date())
                    window.gtag("config", "AW-344077360")
                  }
                  if (!document.getElementById("ads-gtag-script")) {
                    const script = document.createElement("script")
                    script.id = "ads-gtag-script"
                    script.async = true
                    script.src =
                      "https://www.googletagmanager.com/gtag/js?id=AW-344077360"
                    document.head.appendChild(script)
                  }
                }
                const fireAdsConversion = () => {
                  ensureAdsTag()
                  window.gtag("event", "conversion", conversionPayload)
                  try {
                    localStorage.setItem(conversionKey, "1")
                  } catch (err) {}
                }
                // Google Ads conversion tracking.
                fireAdsConversion()

                // BingAds conversion tracking
                /*
                window.uetq = window.uetq || []
                window.uetq.push("event", "purchase", {
                  revenue_value: expected_commission,
                  currency: "GBP",
                })*/
              } catch (err) {
                console.info("ads conversion error", err)
              }
            }
            try {
              if (data.wants_viewing) {
                document.getElementById("viewing-instructions").innerText =
                  data.venue_viewing_instructions
                if (data.virtual_tour_url) {
                  document.getElementById("virtual-tour-link").href =
                    data.virtual_tour_url
                  document
                    .getElementById("viewing-virtual-tour")
                    .classList.remove("hide")
                }
                document
                  .getElementById("viewing-section")
                  .classList.remove("hide")
              }
            } catch (err) {
              util.logToSentry(err)
            }
          } else if (
            data.message &&
            data.message === "Booking already completed for checkout"
          ) {
            document.getElementById("purchase-success").style.display = "none"
            document.getElementById("duplicate-message").style.display = "flex"
            util.logAmplitudeEvent("Purchase Error - Duplicate")
          } else if (!data.is_payment_complete) {
            document.getElementById("purchase-success").style.display = "none"
            document.getElementById("purchase-error").innerHTML =
              "Sorry, we were unable to complete your booking. Please try again later."
            document.getElementById("purchase-error").style.display = "flex"
            util.logAmplitudeEvent(
              "Purchase Error - Booking And Payment Failed",
            )
          } else {
            document.getElementById("purchase-success").style.display = "none"
            document.getElementById("purchase-error").style.display = "flex"
            util.logAmplitudeEvent("Purchase Error - No Data Id")
          }
        } catch (error) {
          document.getElementById("purchase-success").style.display = "none"
          document.getElementById("purchase-error").style.display = "flex"
          util.logAmplitudeEvent("Purchase Error - API Error")
          util.logToSentry("Purchase error for session " + stripeSession)
          util.logToSentry(error)
        }
        document.getElementById("preloader-background").style.display = "none"

        document
          .getElementById("feedback-submit")
          .addEventListener("click", function (e) {
            let feedbackForm = document.getElementById("feedback-form")
            if (feedbackForm.checkValidity()) {
              e.preventDefault()
              let button = document.getElementById("feedback-submit")
              let buttonText = button.value
              window.requestAnimationFrame(() => {
                button.value = "Please wait..."
                button.disabled = true
              })
              util.logAmplitudeEvent("Post Purchase Feedback Submitted", {
                Feedback: document.getElementById("feedback").value,
              })
              document
                .getElementById("feedback-message")
                .classList.remove("hide")
              document
                .getElementById("feedback-form-block")
                .classList.add("hide")
              button.disabled = false
              button.value = buttonText
            } else {
              feedbackForm.reportValidity()
              util.logAmplitudeEvent(
                "Post Purchase Feedback Submitted Without Message",
              )
            }
          })
      } else {
        util.logAmplitudeEvent("Missing Stripe Session ID")
      }
    }

    function init() {
      try {
        complete_booking()
      } catch (err) {
        util.logToSentry(err)
      }
    }

    return {
      init: init,
    }
  })()
}
